<template>
  <l-layer-group
    :layer-type="layerType"
    :name="name"
    :visible="visible"
    :key="focusSatelliteKey"
  >
    <l-marker
      v-for="station in stations"
      :key="`${station.name}@${station.userId}`"
      :lat-lng="station.location"
      :icon="getStationIcon(station.status, isStationReceiving(station))"
      :options="{ className: isStationReceiving(station) ? 'station-receiving' : '' }"
      :visible="!focusSatellite || (station.satellite === focusSatellite && station.status !== 0)"
    >
      <l-popup>
        <h3><router-link :to="`/station/${station.name}@${station.userId}`">{{ station.name }}</router-link></h3><br>
        <strong>{{ (station.status == 0) ? 'Last seen' : 'Last packet' }}:</strong> {{ (station.status == 0) ? formatDate(station.lastSeen) : formatDate(station.lastPacketTime) }} <br>
        <strong>Version:</strong> {{ station.version }} <br>
        <strong>Status:</strong> {{ (station.status == 0) ? 'Offline' : 'Online' }} <br>
        <strong>Listening:</strong> {{ station.satDisplayName }} <br>
      </l-popup>
    </l-marker>
  </l-layer-group>
</template>

<script setup>
import { LLayerGroup, LMarker, LPopup } from 'vue2-leaflet'
import moment from "moment"

const props = defineProps({
  stations: {
    type: Array,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  pingingSatelliteNames: {
    type: Array,
    default: () => []
  },
  focusSatellite: {
    type: String,
    default: null
  },
  focusSatelliteKey: { // <-- new prop
    type: String,
    default: ''
  },
  getStationIcon: {
    type: Function,
    required: true
  },
  layerType: {
    type: String,
    default: 'overlay'
  },
  visible: {
    type: Boolean,
    default: true
  }
})

function formatDate(time) {
  if (!time) return "Never"
  return moment(time).fromNow()
}

function isStationReceiving(station) {
  return station.status === 1 && props.pingingSatelliteNames.includes(station.satellite)
}
</script>